import React from "react";

import Button from "material-ui/Button";
import { withStyles } from "material-ui/styles";
import lightGreen from "material-ui/colors/lightGreen";
import CTable, {
  CTableHead,
  CTableBody,
  CTableRow,
  CHeadCell,
  CBodyCell
} from "uis/CTable";

const styles = () => ({
  tableCellTerm: {
    width: 220
  },
  tableCellAdditionLimit: {
    width: 75
  },
  tableCellLink: {
    width: 80
  },
  bodyCellTerm: {
    fontSize: "0.9rem"
  },
  bodyCellProgress: {
    wordBreak: "keep-all",
    padding: "5px 15px"
  },
  bodyCellLink: {
    padding: 0
  },
  statusLabel: {
    borderRadius: 15,
    color: "white",
    margin: "auto",
    padding: "2px 5px",
    fontSize: ".9rem",
    whiteSpace: "nowrap"
  },
  openRow: {
    backgroundColor: lightGreen[50]
  }
});

const SurveyTable = props => {
  const { classes, surveys, historyPush } = props;

  return (
    <CTable>
      <CTableHead>
        <CTableRow>
          <CHeadCell>アンケート名</CHeadCell>
          <CHeadCell className={classes.tableCellTerm}>公開期間</CHeadCell>
          <CHeadCell>状態</CHeadCell>
          <CHeadCell className={classes.tableCellProgress}>進捗</CHeadCell>
          <CHeadCell className={classes.tableCellAdditionLimit}>
            追加<br />設問数
          </CHeadCell>
          <CHeadCell className={classes.tableCellLink}>{}</CHeadCell>
        </CTableRow>
      </CTableHead>
      <CTableBody>
        {surveys.map(survey => (
          <CTableRow
            key={survey.id}
            className={survey.isOpen() ? classes.openRow : ""}
          >
            <CBodyCell>{survey.surveyName}</CBodyCell>

            <CBodyCell center className={classes.bodyCellTerm}>
              <div>{survey.startDtFmt()} 〜</div>
              <div>{survey.endDtFmt()}</div>
            </CBodyCell>

            <CBodyCell center>
              <div
                className={classes.statusLabel}
                style={survey.backgroundColor()}
              >
                {survey.statusFmt()}
              </div>
            </CBodyCell>

            <CBodyCell center className={classes.bodyCellProgress}>
              <div>{survey.progressRatio()} %</div>
              <div>{survey.progressFmt()}</div>
            </CBodyCell>

            <CBodyCell right className={classes.bodyCellAdditionLimit}>
              {survey.additionLimit}
            </CBodyCell>

            <CBodyCell center className={classes.bodyCellLink}>
              <Button
                onClick={() => historyPush(`/survey_detail/${survey.id}`)}
              >
                詳細
              </Button>
            </CBodyCell>
          </CTableRow>
        ))}
      </CTableBody>
    </CTable>
  );
};

export default withStyles(styles)(SurveyTable);



// WEBPACK FOOTER //
// ./src/components/SurveyTable.jsx